// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4398":"css/app.6686","9219":"css/admin-app.6686"}[chunkId] + ".css";
};